import defaultFavIcon from '@lumapps/assets/brands/favicon.png';
import { get } from '@lumapps/constants';
import type { Instance } from '@lumapps/instance/types';
import { useTranslate } from '@lumapps/translations';

const { isDev } = get();

export const useInstanceFavIcon = () => {
    const { translateObject } = useTranslate();

    const getInstanceFavIcon = (instanceToUse: Instance) => {
        const img = translateObject(instanceToUse?.favicon);

        if (!img || isDev) {
            return defaultFavIcon;
        }

        const imageToUse = img?.startsWith('http') ? img : `/serve/${img}`;

        return imageToUse;
    };

    return getInstanceFavIcon;
};

export { defaultFavIcon };
